import request from '@/utils/request'

export function getList (filters = {}, pagination = {}) {
  return request({
    url: `/list/mm_query`,
    method: 'get',
    headers: {
      'X-filters': JSON.stringify(filters),
      'X-pagination': JSON.stringify(pagination),
      'X-query-debug' : false
    }
  })
}

export function getDetail (id) {
  return request({
    url: '/mm_query/' + id,
    method: 'get'
  })
}



